import React from 'react';
import CTAButton from './CTAButton';
export function SolutionSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-211">
      <div className="max-w-4xl mx-auto" data-id="element-212">
        <div className="bg-green-50 p-5 rounded-lg shadow-lg mb-4 text-center" data-id="element-213">
          <h2 className="text-3xl md:text-5xl font-black text-green-600 mb-3" data-id="element-214">
            💡 PERO ESTO PUEDE CAMBIAR DESDE HOY
          </h2>
        </div>

        <div className="bg-gradient-to-r from-yellow-400 to-orange-500 p-6 rounded-lg shadow-2xl mb-4" data-id="element-215">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-3 text-center" data-id="element-216">
            🚀 PRESENTAMOS:
          </h2>
          <h3 className="text-4xl md:text-6xl font-black text-white mb-3 text-center" data-id="element-217">
            🎓 EDUCACIÓN FINANCIERA DESDE CASA
          </h3>
          <p className="text-xl md:text-2xl text-white text-center font-bold" data-id="element-218">
            El sistema práctico para enseñar a tus hijos a usar el dinero
            correctamente
          </p>
        </div>

        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-219">
          <h3 className="text-2xl md:text-4xl font-black text-gray-800 mb-3" data-id="element-220">
            👨‍👩‍👧 ¿Qué vas a lograr con esto?
          </h3>
          <p className="text-xl mb-3" data-id="element-221">Tu hijo va a aprender:</p>
          <ul className="space-y-2" data-id="element-222">
            <li className="flex items-start" data-id="element-223">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-224">✔</span>
              <span className="text-xl" data-id="element-225">A ahorrar correctamente</span>
            </li>
            <li className="flex items-start" data-id="element-226">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-227">✔</span>
              <span className="text-xl" data-id="element-228">A tomar mejores decisiones</span>
            </li>
            <li className="flex items-start" data-id="element-229">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-230">✔</span>
              <span className="text-xl" data-id="element-231">
                A entender el valor real del dinero
              </span>
            </li>
            <li className="flex items-start" data-id="element-232">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-233">✔</span>
              <span className="text-xl" data-id="element-234">A desarrollar hábitos financieros</span>
            </li>
            <li className="flex items-start" data-id="element-235">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-236">✔</span>
              <span className="text-xl" data-id="element-237">A pensar diferente desde pequeño</span>
            </li>
          </ul>
          <p className="text-xl font-bold mt-3" data-id="element-238">
            👉 Una ventaja que la mayoría no tiene.
          </p>
        </div>

        <CTAButton text="¡QUIERO TRANSFORMAR A MI HIJO!" data-id="element-239" />
      </div>
    </section>;
}
export default SolutionSection;